export const parseKitchenAnswers = (data: any) => {
  const answers: any = {};

  answers.kitchen_tap_count = {
    count: Object.keys(data?.taps || {}).length,
    groups: [],
  };

  Object.values(data?.taps || {}).forEach((tap: any) => {
    answers.kitchen_tap_count.groups.push({
      kitchen_tap_type: tap.type || '',
      kitchen_tap_flow_rate: tap.flowrate || '',
      kitchen_tap_leak: tap.leak || '',
    });
  });

  answers.kitchen_appliances = {
    count: 0,
    groups: [],
    use_kettle: data.kitchen_kettle_boil_water || '',
    dishwasher_usage_per_week: data.dishwasher_per_week ?? 0,
    washing_up_method: data.used_for_wash_up || '',
  };

  return answers;
};
